import items from './items';
import simpleViewAttributes from './simpleViewAttributes';
import leadGate from './leadGate';

const root = {
	items,
	simpleViewAttributes,
	leadGate
};

export default root;
